module.exports = __webpack_public_path__ + "static/media/portal-showcase.f509f231.webm";